import { loadable } from "components/SpruceLoader";

export const Host = loadable(() => import("./host/index"));
